var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-suggestions-row",style:(_vm.containerStyle)},_vm._l((_vm.quickReplies),function(qr,i){return _c('button',{key:i,staticClass:"sc-suggestions-element",style:(_vm.styles)},[_vm._v(" "+_vm._s(qr)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }